import { BlitzPage, Routes } from "@blitzjs/next";
import Layout from "src/app/core/layouts/Layout"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { StudioLoginPage } from "src/app/studio/feature-login/StudioLoginPage"

const StudioLogin: BlitzPage = () => {
  return <StudioLoginPage />
}

StudioLogin.redirectAuthenticatedTo = Routes.StudioIndex()
StudioLogin.getLayout = (page) => <Layout title="Log In">{page}</Layout>

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "studio"])),
      // Will be passed to the page component as props
    },
  }
}

export default StudioLogin
